import React from 'react';

interface UseUserDeletionProps {
    handleRemove: (id: number) => void;
    handleDeleteMultiple: () => void;
}

export const useUserDeletion = ({ handleRemove, handleDeleteMultiple }: UseUserDeletionProps) => {
    const [deleteUserProfileId, setDeleteProfileId] = React.useState<number>();
    const [bulkDeleteUsers, setBulkDeleteUsers] = React.useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState<boolean>(false);

    // Handle single user removal
    const handleRemoveUser = (userProfileId: number) => {
        setDeleteProfileId(userProfileId);
        setShowDeleteModal(true);
    };

    // Handle bulk user removal
    const handleBulkRemoveUser = (selectedRows: any[]) => {
        if (selectedRows.length > 0) {
            setBulkDeleteUsers(true);
            setShowDeleteModal(true);
        }
    };

    // Execute the deletion
    const handleProfileDeletion = () => {
        /* Action: Single Delete */
        if (deleteUserProfileId) {
            handleRemove(deleteUserProfileId);
            setDeleteProfileId(undefined);
        }

        /* Action: Bulk Delete */
        if (bulkDeleteUsers) {
            handleDeleteMultiple();
            setBulkDeleteUsers(false);
        }

        setShowDeleteModal(false);
    };

    // Close the modal without deleting
    const onCloseDeleteModal = () => {
        setDeleteProfileId(undefined);
        setBulkDeleteUsers(false);
        setShowDeleteModal(false);
    };

    return {
        // State
        deleteUserProfileId,
        bulkDeleteUsers,
        showDeleteModal,
        
        // Actions
        handleRemoveUser,
        handleBulkRemoveUser,
        handleProfileDeletion,
        onCloseDeleteModal
    };
};
